import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill-new";
import { Box, Button, Typography } from "@mui/material";
import "react-quill-new/dist/quill.snow.css";
import styled from "styled-components";
import { setMessage } from "../../stores/orders";
import { useAppDispatch } from "../../stores/store";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
interface messagePropType {
  handleSend?: any;
  selectedFiles: any[];
  setSelectedFiles: any;
  sentMessage?: "";
  isLoading?: boolean;
  isMessageBox?: any;
}
export default function MessageEditor(props: messagePropType) {
  const {
    handleSend,
    selectedFiles,
    setSelectedFiles,
    isLoading,
    isMessageBox,
  } = props;

  const dispatch = useAppDispatch();
  const [value, setValue] = useState("");

  const handleImageUpload = () => {
    document.getElementById("attachment")?.click();
  };

  const fileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      const newFiles = Array.from(files).map((file) => ({
        file,
        preview: URL.createObjectURL(file),
      }));

      setSelectedFiles((prev: any) => [...prev, ...newFiles]);
      e.target.value = ""; // reset input so same file can be selected again
    }
  };

  const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image"],
        ["clean"],
      ],
      handlers: {
        image: handleImageUpload,
      },
    },
  };
  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
  ];

  const handleCancel = () => {
    dispatch<any>(setMessage(""));
    setValue(""); // Clear the editor on cancel
    isMessageBox(false);
  };

  const handleChange = (message: any) => {
    setValue(message);
    dispatch<any>(setMessage(message));
  };

  const getTextLength = (html: string) => {
    const text = html.replace(/<[^>]*>/g, "").trim();
    return text.length;
  };

  return (
    <Box sx={{ position: "relative" }} id="MessageEditor">
      <input
        type="file"
        id="attachment"
        onChange={fileChange}
        multiple
        style={{ visibility: "hidden", position: "absolute" }}
      />
      <CustomQuill
        theme="snow"
        value={value}
        onChange={(content: string) => handleChange(content)}
        placeholder="Send a client message or drop a file here to attach it..."
        modules={modules}
        formats={formats}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "11px",
          right: "10px",
          display: "flex",
          padding: "0",
          justifyContent: "space-between",
          alignItems: "end",
          width: "98%",
        }}
      >
        {selectedFiles.length > 0 && (
          <Box
            sx={{
              display: "flex",
              gap: 2,
              overflowX: "auto",
              marginTop: 1,
              "&::-webkit-scrollbar": {
                height: "6px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#ccc",
                borderRadius: "4px",
              },
            }}
          >
            {selectedFiles.map((item, index) => (
              <Box
                key={index}
                sx={{
                  flex: "0 0 auto", // prevents shrinking & keeps fixed width
                  width: 42,
                  height: 42,
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  position: "relative",
                  overflow: "hidden",
                  marginLeft: "8px",
                }}
              >
                <img
                  src={item.preview}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  alt="img"
                />
                <Button
                  size="small"
                  color="error"
                  onClick={() =>
                    setSelectedFiles((prev: any) =>
                      prev.filter((_: any, i: any) => i !== index),
                    )
                  }
                  sx={{
                    position: "absolute",
                    top: -1,
                    right: 1,
                    minWidth: "unset",
                    // padding: "2px 6px",
                    fontSize: "1rem",
                    width: "24px",
                    height: "24px",
                  }}
                >
                  ×
                </Button>
              </Box>
            ))}
          </Box>
        )}
        {getTextLength(value) > 0 && (
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              width: selectedFiles.length === 0 ? "100%" : "fit-content",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="outlined"
              onClick={handleCancel}
              sx={{ width: "120px", height: "41px" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              // disabled={isLoading}
              onClick={() => {
                handleSend();
                setValue("");
                setSelectedFiles([]);
              }}
              sx={{
                width: "120px",
                height: "41px",
                background:
                  " linear-gradient(98.24deg, #2977CC 4.13%, #1D538F 128.24%)",
              }}
            >
              Send
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
}
const CustomQuill = styled(ReactQuill)(({ theme }) => ({
  direction: "ltr",
  ".ql-editor": {
    direction: "ltr",
    textAlign: "left",
  },
  ".ql-toolbar.ql-snow": {
    backgroundColor: "#EAF1FA91",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
    border: "2px solid #2977CC",
    padding: "10px",
  },
  ".ql-container.ql-snow": {
    border: "2px solid #2977CC",
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
    height: "230px",
    paddingBottom: "60px",
    overflowY: "auto",
  },
  ".ql-editor li": {
    direction: "ltr",
    textAlign: "left",
  },
  ".ql-editor ul": {
    direction: "ltr",
    textAlign: "left",
    listStyleType: "disc",
    marginLeft: "20px",
  },
  ".ql-editor ol": {
    direction: "ltr",
    textAlign: "left",
    listStyleType: "decimal",
    marginLeft: "20px",
  },
}));
